import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import ProcessInformation from "@/components/ProcessInformation";
import { ButtonLink } from "@/components/Buttons";
import { rightViewTerm } from "@/components/RightViewTerm";
import formatPrice from "@/lib/formatPrice";
import { PAYMENT_METHOD_NAMES } from "@/lib/constants";
import routes from "@/lib/routes";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PurchaseFormStep3(_ref) {
  var _purchaseData$order, _purchaseData$order2, _product$meta, _product$meta2;

  var product = _ref.product,
      purchaseData = _ref.purchaseData;
  var price = formatPrice(purchaseData === null || purchaseData === void 0 ? void 0 : (_purchaseData$order = purchaseData.order) === null || _purchaseData$order === void 0 ? void 0 : _purchaseData$order.payment_amount);
  var paymentMethod = purchaseData === null || purchaseData === void 0 ? void 0 : (_purchaseData$order2 = purchaseData.order) === null || _purchaseData$order2 === void 0 ? void 0 : _purchaseData$order2.payment_method_id;

  var _rightViewTerm = rightViewTerm(product === null || product === void 0 ? void 0 : product.right),
      _rightViewTerm2 = _slicedToArray(_rightViewTerm, 2),
      rightLabel = _rightViewTerm2[0],
      rightText = _rightViewTerm2[1];

  var metaId = product === null || product === void 0 ? void 0 : (_product$meta = product.meta) === null || _product$meta === void 0 ? void 0 : _product$meta.id;
  return /*#__PURE__*/_jsxs(ProcessInformation, {
    complete: true,
    header: "\u8CFC\u5165\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(styles.container, " ").concat(styles.center),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.section,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.sectionLeft,
          children: /*#__PURE__*/_jsx("img", {
            src: product.thumbnailUrl
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.sectionRight,
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles.title,
            children: product.name
          }), /*#__PURE__*/_jsxs("div", {
            className: "".concat(styles.info, " ").concat(styles.price),
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u4FA1\u683C"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs("span", {
                  className: styles.priceAmount,
                  children: [price, "\u5186"]
                }), "\uFF08\u7A0E\u8FBC\uFF09"]
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: rightLabel
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: rightText
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "".concat(styles.info, " ").concat(styles.paymentMethod),
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.left,
              children: "\u652F\u6255\u65B9\u6CD5"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.right,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.paymentMethodName,
                children: PAYMENT_METHOD_NAMES[paymentMethod]
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.btnArea,
      children: /*#__PURE__*/_jsxs(ButtonLink, {
        href: routes.watch(metaId),
        fillColor: true,
        large: true,
        children: [product === null || product === void 0 ? void 0 : (_product$meta2 = product.meta) === null || _product$meta2 === void 0 ? void 0 : _product$meta2.name, "\u3092\u8996\u8074\u3059\u308B"]
      })
    })]
  });
}